'use strict';

/**
 * An adapter for customer sections data provider with support of Web Lock API.
 */
class CustomerSectionsLockable {
}

export default CustomerSectionsLockable;
